import { useEffect, useState } from 'react';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientsItem.css';
import { Link } from 'react-router-dom';
import { updatePreferences } from '../../utilities/api/users';

export default function ClientsItem({clientItem, clientsPreferences, setDocketPreferences, user, updateUser, isMobile, favoriteClients, toggleNotifications}) {
    const [ isFavorite, setIsFavorite ] = useState(false);
    const [ isChangingPreferences, setIsChangingPreferences ] = useState(false);

    const handleFavoriteClick = async () => {
        const tempFavoriteClients = [...favoriteClients];
        setIsChangingPreferences(true);
        if (isFavorite) {
            const index = tempFavoriteClients.indexOf(clientItem._id);
            if (index > -1) {
                tempFavoriteClients.splice(index, 1);
            }
        } else {
            tempFavoriteClients.push(clientItem._id);
        }
        try {
            const res = await updatePreferences(user._id, { docketPreferences: { ...user.docketPreferences, favoriteClients: tempFavoriteClients } });
            setIsFavorite(!isFavorite);
            window.localStorage.setItem('token', res.token)
            updateUser(res.updatedUser)
            setDocketPreferences(res.updatedUser.docketPreferences)
            toggleNotifications('success', isFavorite ? 'Removed from Favorite Clients.' : 'Added to Favorite Clients.', isFavorite ? '#FF0000' : '#FFFFFF');
        } catch (error) {
            console.log(error);
            toggleNotifications('error', 'Error updating favorite clients. Please try again.', '#FFFFFF');
        } finally {
            setIsChangingPreferences(false);
        }
    }

    useEffect(() => {
        setIsFavorite((user.docketPreferences.favoriteClients.includes(clientItem._id)) || false);
    }, [user, clientItem]);

  return (
    <tr className='ClientsItem'>
        { !clientsPreferences.includes('companyName') &&
        <td className='companyName'>
            <div className='companyNameContent'>
                <div className='d-flex align-items-center favoriteStar' onClick={handleFavoriteClick} disabled={!isChangingPreferences} title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}>
                    {isFavorite ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" className="bi bi-star" viewBox="0 0 16 16">
                        <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                    </svg>
                    }
                </div>
                <Link to={`/clients/${clientItem._id}`}>{capitalizeFirstLetter(clientItem.companyName)}</Link>
            </div>
        </td>
        }
        { !clientsPreferences.includes('clientID') &&
        <td className='clientID'>{clientItem.clientID? clientItem.clientID:'---'}</td>
        }
        { !clientsPreferences.includes('companyEmail') &&
        <td className='companyEmail'>{clientItem.companyEmail? clientItem.companyEmail:'---'}</td>
        }
        { !clientsPreferences.includes('companyPhoneNumber') &&
        <td className='companyPhoneNumber'>{clientItem.companyPhoneNumber? clientItem.companyPhoneNumber:'---'}</td>
        }
        { !clientsPreferences.includes('province') &&
        <td className='province'>{clientItem.province? clientItem.province:'---'}</td>
        }
        { !clientsPreferences.includes('createdAt') &&
        <td className='createdAt'>
            <div>
                {new Date(clientItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        }
        { !clientsPreferences.includes('updatedAt') &&
        <td className='lastUpdate'>
            <div>
                {new Date(clientItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        }
    </tr>
  )
}
